export const APP_NAME = 'DCA';
